"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisplayMediaPerRow = exports.useRaceForRewardsPlayers = void 0;
const react_1 = require("react");
const useWindowSize_1 = require("root/src/client/v2/common/hooks/useWindowSize");
const DEFAULT_DISPLAY_MEDIA_ITEMS = 2;
const displayMediaBreakpoints = [
    { width: 1550, items: 3 },
    { width: 0, items: 2 },
];
const useRaceForRewardsPlayers = (media) => {
    const displayMediaPerRow = (0, exports.useDisplayMediaPerRow)();
    const [totalDisplayMedia, setTotalDisplayMedia] = (0, react_1.useState)(displayMediaPerRow);
    const [displayedMedia, setDisplayedMedia] = (0, react_1.useState)([]);
    const onShowMoreClick = () => {
        if (totalDisplayMedia < media.length) {
            setTotalDisplayMedia(totalDisplayMedia + displayMediaPerRow);
        }
    };
    (0, react_1.useEffect)(() => {
        const isAligned = totalDisplayMedia % displayMediaPerRow === 0;
        if (!isAligned) {
            setTotalDisplayMedia((prevValue) => {
                const neededCountToBeAligned = (Math.ceil(totalDisplayMedia / displayMediaPerRow) * displayMediaPerRow) - totalDisplayMedia;
                return prevValue + neededCountToBeAligned;
            });
        }
    }, [displayMediaPerRow]);
    (0, react_1.useEffect)(() => {
        setDisplayedMedia(media.slice(0, totalDisplayMedia));
    }, [totalDisplayMedia]);
    const isAutoplay = (index) => index === 0;
    const displayShowMore = displayedMedia < media;
    return {
        displayedMedia,
        displayShowMore,
        onShowMoreClick,
        isAutoplay,
    };
};
exports.useRaceForRewardsPlayers = useRaceForRewardsPlayers;
const useDisplayMediaPerRow = () => {
    const [width] = (0, useWindowSize_1.useWindowSize)();
    const currentBreakpoint = displayMediaBreakpoints.find(breakpoint => width > breakpoint.width);
    if (!currentBreakpoint) {
        return DEFAULT_DISPLAY_MEDIA_ITEMS;
    }
    return currentBreakpoint.items;
};
exports.useDisplayMediaPerRow = useDisplayMediaPerRow;
